﻿/* iMD — site interactions (no dependencies) */
(function () {
  "use strict";

  /* Reveal animations only apply when JS runs — without this class,
     CSS keeps all content fully visible (no-JS users, crawlers). */
  document.documentElement.classList.add("js-anim");

  /* ----- Sticky nav ----- */
  var nav = document.querySelector(".nav");
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle("nav--solid", window.scrollY > 12);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ----- Mobile menu ----- */
  var burger = document.querySelector(".nav__burger");
  var links = document.querySelector(".nav__links");
  if (burger && links) {
    burger.addEventListener("click", function () {
      var open = links.classList.toggle("is-open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    links.addEventListener("click", function (e) {
      if (e.target.tagName === "A") {
        links.classList.remove("is-open");
        burger.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* ----- Scroll-reveal ----- */
  /* Two mechanisms: an IntersectionObserver (fires however the page is
     scrolled, including compositor/restored scrolls) and an rAF sweep on
     scroll/resize (catches elements jumped PAST, which never intersect). */
  var pendingReveal = Array.prototype.slice.call(document.querySelectorAll(".reveal, .reveal-stagger"));
  if (pendingReveal.length) {
    var revealIo = null;
    var markVisible = function (el) {
      el.classList.add("is-visible");
      if (revealIo) revealIo.unobserve(el);
    };
    if ("IntersectionObserver" in window) {
      revealIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
            markVisible(entry.target);
            pendingReveal = pendingReveal.filter(function (el) { return el !== entry.target; });
          }
        });
      }, { threshold: 0.05 });
      pendingReveal.forEach(function (el) { revealIo.observe(el); });
    }
    var lastSweep = 0;
    var sweep = function () {
      var limit = window.innerHeight * 0.96;
      pendingReveal = pendingReveal.filter(function (el) {
        if (el.getBoundingClientRect().top < limit) {
          markVisible(el);
          return false;
        }
        return true;
      });
      if (!pendingReveal.length) {
        window.removeEventListener("scroll", onSweep);
        window.removeEventListener("resize", onSweep);
      }
    };
    /* plain time-throttle, not rAF — rAF never fires in throttled/background
       tabs, which would leave restored scroll positions unrevealed */
    var onSweep = function () {
      var now = Date.now();
      if (now - lastSweep > 90) { lastSweep = now; sweep(); }
      else { setTimeout(function () { if (Date.now() - lastSweep > 90) { lastSweep = Date.now(); sweep(); } }, 100); }
    };
    window.addEventListener("scroll", onSweep, { passive: true });
    window.addEventListener("resize", onSweep, { passive: true });
    sweep();
  }

  /* ----- Animated counters (data-count attr) ----- */
  var counters = document.querySelectorAll("[data-count]");
  if ("IntersectionObserver" in window && counters.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        cio.unobserve(el);
        var target = parseFloat(el.getAttribute("data-count"));
        var suffix = el.getAttribute("data-suffix") || "";
        var prefix = el.getAttribute("data-prefix") || "";
        var dur = 1600, start = null;
        var fmt = function (n) { return n >= 1000 ? n.toLocaleString("en-US") : String(n); };
        var tick = function (ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + fmt(Math.round(target * eased)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  /* ----- Hero search typing effect ----- */
  var typeEl = document.querySelector("[data-typer]");
  if (typeEl) {
    var phrases = ["UWorld Step 1 QBank", "AMBOSS Library", "UpToDate", "Sketchy Micro", "Boards & Beyond", "Pathoma Ch. 1–23"];
    var pi = 0, ci = 0, deleting = false;
    var loop = function () {
      var word = phrases[pi];
      typeEl.textContent = word.slice(0, ci);
      var delay = deleting ? 34 : 72;
      if (!deleting && ci === word.length) { delay = 1500; deleting = true; }
      else if (deleting && ci === 0) { deleting = false; pi = (pi + 1) % phrases.length; delay = 350; }
      ci += deleting ? -1 : 1;
      setTimeout(loop, delay);
    };
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) setTimeout(loop, 800);
    else typeEl.textContent = phrases[0];
  }

  /* ----- Resource explorer: search + category filter ----- */
  var resGrid = document.getElementById("resGrid");
  if (resGrid) {
    var searchInput = document.getElementById("resSearch");
    var chips = Array.prototype.slice.call(document.querySelectorAll(".chip[data-cat]"));
    var cards = Array.prototype.slice.call(resGrid.querySelectorAll(".res-card"));
    var emptyEl = document.getElementById("resEmpty");
    var countEl = document.getElementById("resCount");
    var activeCat = "all";

    var apply = function () {
      var q = (searchInput ? searchInput.value : "").trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (card) {
        var matchCat = activeCat === "all" || card.getAttribute("data-cat") === activeCat;
        var matchQ = !q || card.textContent.toLowerCase().indexOf(q) !== -1;
        var show = matchCat && matchQ;
        card.style.display = show ? "" : "none";
        if (show) shown++;
      });
      if (emptyEl) emptyEl.style.display = shown ? "none" : "block";
      if (countEl) countEl.textContent = "Showing " + shown + " featured resource" + (shown === 1 ? "" : "s") + " — your subscription includes 45,000+ in total.";
    };

    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("is-active"); });
        chip.classList.add("is-active");
        activeCat = chip.getAttribute("data-cat");
        apply();
      });
    });
    if (searchInput) searchInput.addEventListener("input", apply);
    apply();
  }

  /* ----- Voices rotator ----- */
  var stage = document.querySelector("[data-rotator]");
  if (stage) {
    var voices = Array.prototype.slice.call(stage.querySelectorAll(".voice"));
    var dots = Array.prototype.slice.call(stage.querySelectorAll(".voices__dots button"));
    var idx = 0, timer = null;
    var show = function (n) {
      idx = (n + voices.length) % voices.length;
      voices.forEach(function (v, i) { v.classList.toggle("is-active", i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
    };
    var play = function () {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      timer = setInterval(function () { show(idx + 1); }, 6500);
    };
    dots.forEach(function (d, i) {
      d.addEventListener("click", function () {
        clearInterval(timer);
        show(i);
        play();
      });
    });
    stage.addEventListener("mouseenter", function () { clearInterval(timer); });
    stage.addEventListener("mouseleave", function () { clearInterval(timer); play(); });
    play();
  }

  /* ----- Footer year ----- */
  var yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();
})();
